import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbdModalContent } from 'app/components/bootstrap/modals/modals.component';
import { ApiService } from 'app/shared/services/api.service';
import { TransactionModalContent } from 'app/shared/transaction-modal/transaction-modal.component';

@Component({
  selector: 'app-payment-history',
  templateUrl: './payment-history.component.html',
  styleUrls: ['./payment-history.component.scss']
})
export class PaymentHistoryComponent implements OnInit {

  public userId: any;
  public userName: any;
  userData: any
  transactionData: any;
  constructor(private apiService: ApiService, private modalService: NgbModal,
    private activatedroute: ActivatedRoute) {
    this.activatedroute.paramMap.subscribe(params => {
      this.userId = params.get('id');
      console.log('userId transaction-history', this.userId)
    });

  }

  ngOnInit() {
    this.getUserById();
  }
  getUserById() {
    this.apiService.getStudentById(this.userId).subscribe((res: any) => {
      console.log('user', res)
      this.userData = res.data
      this.userName = this.userData.name;
      this.getTransactionsByUserId();
    })
  }
  getTransactionsByUserId() {
    this.apiService.getTransactionUserById(this.userId).subscribe((res: any) => {
      this.transactionData = res.data;
      console.log('transactionData by userid Data', this.transactionData)
    })
  }
  openContent() {
    const modalRef = this.modalService.open(TransactionModalContent);
    modalRef.componentInstance.userId = this.userId
    modalRef.componentInstance.userName = this.userName
    modalRef.componentInstance.transactionData = this.transactionData
    modalRef.result.then((data) => {
      console.log("mode close>>>>>>>>>>>>", data)
      if (data == "success") {
        this.getTransactionsByUserId()
      }
      // on close
    }, (reason) => {
      // on dismiss
    });
  }
}
